import React from "react";
import { FaLinkedinIn, FaGithub } from "react-icons/fa";
import { RiWhatsappFill } from "react-icons/ri";
import { AiFillInstagram } from "react-icons/ai";
import {
  Infosection,
  Left,
  Tittle,
  Color,
  StyledButton,
  SocialIcon,
  Url,
  Right,
  Image,
  StyledSecButton,
} from "./homeComponents";
// import { useSelector } from "react-redux";
import { home } from "../../assets/data";
import {Model} from "../../blenderFile";
import { Canvas } from "@react-three/fiber";
import { OrbitControls } from "@react-three/drei";
// import Particles from "react-particles-js";

const Scene = () => {
  return (
    <Canvas camera={{ position: [2, 0, 12.25], fov: 15 }}>
        <ambientLight intensity={4} />
        <OrbitControls enableZoom={false} />
        <Model  position={[0.025, -0.9, 0]} />
      </Canvas>
  )
}

const Home = ({ activeColor }) => {
  //   const imageDocs = useSelector((state) => state.root.imageDocs);
  //   console.log("from Home", imageDocs);

  return (
    <Infosection fluid="xl" id="home">
      <Left>
        <Tittle className="home__title">
          {home.text1} <br /> {home.text2}{" "}
          <Color color={activeColor}>{home.tittle}</Color>
          <br />
          {home.text3}
        </Tittle>
        <StyledSecButton
          color={activeColor}
          to="projects"
          smooth={true}
          offset={-70}
          duration={1000}
          spy={true}
          className="button"
        >
          {home.button1}
        </StyledSecButton>
        <StyledButton
          color={activeColor}
          to="contact"
          smooth={true}
          offset={-70}
          duration={1000}
          spy={true}
          className="button"
        >
          {home.button}
        </StyledButton>
      </Left>
      <SocialIcon className="home__social-icon">
        <Url href="https://www.linkedin.com/in/sathish-k-7b5b5417b">
          <FaLinkedinIn style={{ fontSize: 26, color: "#0e76a8" }} />
        </Url>
        <Url href="https://wa.me/918122126380">
          <RiWhatsappFill style={{ fontSize: 26, color: "green" }} />
        </Url>
        <Url href="https://github.com/sathish2416">
          <FaGithub style={{ fontSize: 24, color: "#000" }} />
        </Url>
        <Url href="https://www.instagram.com/k_sathish_98">
          <AiFillInstagram
            style={{ fontSize: 28, color: "#fa8072" }}
            id="insta"
          />
        </Url>
      </SocialIcon>
      <Right className="home__img">
      <Scene />
      </Right>
    </Infosection>
  );
};

export default React.memo(Home);
